import type { CustomReportItemIdentityInterface } from '@nts/std/interfaces';
import { GeneratedCustomReportItemIdentity } from './generated-custom-report-item.identity';

export class CustomReportItemIdentity extends GeneratedCustomReportItemIdentity implements CustomReportItemIdentityInterface {

}
